// Save text interview answer list **************************************************************
// pathname: /v1/job-interview/save-text-answer-list
// ************************************************************************************************
import { useSwrMutationApi, GenericV1ErrorsArray } from 'src/hooks/useSwrApi';

interface UseSwrJobInterviewSaveTextAnswerListProps {
  locale?: string;
  successCallback?: (response: ApiSchema<'InterviewTextAnswerListRead'>) => void;
  errorCallback?: (error: GenericV1ErrorsArray) => void;
}

/**
 * @description SWR hook: Save text interview answer list
 * - POST /v1/job-interview/save-text-answer-list
 * - @param locale - The current app locale. Default: 'ro'
 * - @param successCallback - Function to call on successful save
 * - @param errorCallback - Function to call on error
 *
 * @example
 * const { data, trigger, isMutating, error } = useSwrJobInterviewSaveTextAnswerList({
 *   locale: 'ro',
 *   successCallback: (response) => {
 *     console.log('Answers saved:', response);
 *   },
 *   errorCallback: (error) => {
 *     console.error('Failed to save:', error);
 *   }
 * });
 *
 * // Trigger the save
 * trigger({
 *   textAnswers: [
 *     { questionId: 1, answerText: 'My answer' }
 *   ]
 * });
 */
export const useSwrJobInterviewSaveTextAnswerList = (
  props: UseSwrJobInterviewSaveTextAnswerListProps = {},
) => {
  const {
    locale = 'ro',
    successCallback,
    errorCallback,
  } = props;

  return useSwrMutationApi<ApiSchema<'InterviewTextAnswerListRead'>, ApiSchema<'InterviewTextAnswerListWrite2'>>({
    url: '/v1/job-interview/save-text-answer-list',
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
    apiOptions: {
      onSuccess: (response) => {
        if (successCallback) {
          successCallback(response);
        }
      },
      onError: (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });
};

